import { useCallback, useState } from "react";

export type U3121ExportProjectOpeningFormPdfPayload = { lang?: "fr" | "en" };

export interface UseU3121ExportProjectOpeningFormPdfHandlersProps {
  doExportProjectOpeningFormPdfFn: (projectId: string, payload?: U3121ExportProjectOpeningFormPdfPayload) => Promise<unknown>;
  onSuccess: () => void;
  onError: (params: { error: unknown }) => void;
}

export function useU3121ExportProjectOpeningFormPdfHandlers({
  doExportProjectOpeningFormPdfFn,
  onSuccess,
  onError,
}: UseU3121ExportProjectOpeningFormPdfHandlersProps) {
  const [isExporting, setIsExporting] = useState(false);

  const exportProjectOpeningFormPdf = useCallback(
    async (projectId: string, lang?: "fr" | "en") => {
      if (!projectId?.trim()) return;
      setIsExporting(true);
      try {
        const payload = lang != null ? { lang } : undefined;
        await doExportProjectOpeningFormPdfFn(projectId, payload);
        onSuccess();
      } catch (error: unknown) {
        onError({ error });
      } finally {
        setIsExporting(false);
      }
    },
    [doExportProjectOpeningFormPdfFn, onSuccess, onError]
  );

  return { exportProjectOpeningFormPdf, isExporting };
}
